import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { ref } from '@dbk-legacy/muster/utils';
import capitalize from 'lodash/capitalize';
import Error from '../../../components/common/error';
import { LoadingCircle } from '../../../components/common/loading';
import AbbreviatedNotes from '../../../components/common/abbreviated-notes';
import AssetHeader from './asset-header/asset-header-container';
import AssetPosition from './asset-position/asset-position-container';
import AssetPositionDetails from './asset-position-details/asset-position-details-container';
import ScrollableLayout from '../../../components/common/scrollable-layout';
import AssetPositionModal from './asset-position-modal';
import SortingHeader from '../../../components/common/sorting-header/sorting-header-container';
import Pagination from '../../../components/common/pagination';
import NavigationBar from '../../../components/common/navigation-bar';
import { StickyContainer, Sticky } from 'react-sticky';
import AssetAccordion from '../../../components/common/asset-accordion/asset-accordion.container';
import LayoutContainer from '../../../components/common/layout';
import styles from './asset-positions-factory.styles';
import { ROUTES } from '../../../constants'

class Header extends PureComponent {
  render() {
    const { portfolio, ui, search, screen, i18n: { messages } } = this.props.inputs;
    const assetData = portfolio[this.props.assetCategory];
    const referenceCurrency = portfolio.referenceCurrency;
    const uiStatic = assetData.static;
    const uiSortingState = ui.state.portfolio[this.props.assetCategory];
    return (
      <div style={{ ...this.props.style, overflow: 'auto' }}>
        <SortingHeader
          currency={referenceCurrency}
          uiStatic={uiStatic}
          state={uiSortingState}
          screen={screen}
          messages={messages}
          enabled
        />
      </div>
    );
  }
}

export default function assetPositionsFactory({
  assetCategory,

  HeaderComponent = AssetHeader,
  SortingHeaderComponent = SortingHeader,
  RowComponent = AssetPosition,
  ExpandedRowComponent = AssetPositionDetails,
}) {
  const positionsProp = assetCategory === 'mmInstruments' ? 'positionsAlias' : 'positions';

  class AssetPositions extends PureComponent {
    constructor() {
      super();
      this.handlePageChange = this.handlePageChange.bind(this);
      this.handleCtaClick = this.handleCtaClick.bind(this);  
    }

    // Function to handle the BUY/SELL click actions
    // params:  orderType and row
    handleCtaClick(orderType, row) {     
      const positionEntryProps = {};
      positionEntryProps.type = orderType;
      positionEntryProps.assetId = row.number;
      positionEntryProps.isPositionEntry = true;
      positionEntryProps.posId = row.secID;
      // TODO: this field might be removed in future once quantity implementation is confirmed
      positionEntryProps.quantityHeld = row.quantity; 
      positionEntryProps.selectedPortfolio = this.props.app.user.selectedPortfolio;
      this.props.setComponentProps(positionEntryProps);
      this.props.setInitialPath(ROUTES.TRADE.NEW_ORDER);
      this.props.changePage(ROUTES.TRADE.LIBRARY);
    }

    handlePageChange() {
      // this.rootView.handleScrollTo(0);
    }
    render() {
      const { portfolio, ui, search, screen, i18n: { messages }, marque } = this.props;
      const assetData = portfolio[assetCategory];
      const uiStatic = assetData.static;
      const uiState = assetData.state;
      const uiSortingState = ui.state.portfolio[assetCategory];
      const referenceCurrency = portfolio.referenceCurrency;
      const assetNames = portfolio.assetNames != null ? portfolio.assetNames : [];
      // const rows = assetData.positionsSorted.filter(row => {
      //   if (search.filter.positionId !== null) {
      //     return row.security.id === search.filter.positionId;
      //   } else {
      //     return row;
      //   }
      // });
      const isFiltered = search.filter.positionId !== null && search.filter.positionId !== undefined;
      let rows = [];
      if (isFiltered) {
        rows = [assetData.positionsByPosId];
      } else {
        rows = assetData.positionsSorted;
      }
      const assetPositions = assetData[positionsProp];

      let stickyTabFixedTop;
      stickyTabFixedTop = screen.isSmall ? 79 : 127 // sticky-header height 48px
      if (!marque.loginDissmiss)
        stickyTabFixedTop += 40
      return (
        <LayoutContainer>
          <div className='asset-positions'>
            {!screen.isSmall &&
              <div className="stick-header" id="header_positionDrildown_assetPositionFactory_test"><NavigationBar assetNames={assetNames} messages={messages} /></div>
            }
            <StickyContainer style={{ minHeight: screen.height / 2.4 }}>
              <View style={styles.root}>
                <HeaderComponent assetData={assetData} currency={referenceCurrency} messages={messages} />
              </View>
              <Sticky fixedTop={stickyTabFixedTop}>
                {
                  ({ isSticky, wasSticky, style, distanceFromTop, distanceFromBottom, calculatedHeight }) => {
                    return <Header style={style} assetCategory={assetCategory} inputs={this.props} messages={messages} />
                  }
                }
              </Sticky>
              <ScrollableLayout
                body={
                  <View>
                    <AssetAccordion
                      uiStatic={uiStatic}
                      state={uiState}
                      rows={rows}
                      messages={messages}
                      renderRow={row => <RowComponent
                        row={row}
                        assetData={assetData}
                        referenceCurrency={referenceCurrency}
                        screen={screen}

                      />}
                      renderRowExpanded={(row) => <ExpandedRowComponent
                        uiStatic={uiStatic}
                        row={row}
                        messages={messages}
                        assetCategory={assetCategory}
                        landscapeComponent={AssetPositionModal}
                        referenceCurrency={referenceCurrency}
                        abbreviationRules={ui.static.abbreviationRules}
                        screen={screen}
                        handleCtaClick={this.handleCtaClick}
                        isVascoActivated={this.props.auth.vascoActivated}
                        selectedPortfolio={this.props.app.user.selectedPortfolio}                     
                        entitledForTrading={this.props.auth.entitlements.trading}
                      />}
                      footer={
                        <View>
                          <AbbreviatedNotes />
                          {!isFiltered &&
                            <Pagination
                              pageOffset={assetPositions.pageOffset}
                              pageSize={assetPositions.pageSize}
                              totalRecords={assetPositions.length}
                              setPageOffset={assetPositions.setPageOffset}
                              onPageChange={this.handlePageChange}
                              style={{ marginVertical: 20 }} />
                          }
                        </View>
                      }
                    />
                  </View>
                } />
            </StickyContainer>
          </div>
        </LayoutContainer>
      );
    }
  }

  AssetPositions.propTypes = {
    portfolio: PropTypes.shape({
      referenceCurrency: PropTypes.string,
      [assetCategory]: PropTypes.object,
    }),
    ui: PropTypes.object,
  };

  AssetPositions.displayName = `${capitalize(assetCategory)}AssetPositions`;

  return createContainer({
    $renderError: () => <Error />,
    $renderLoading: () => <LoadingCircle isPage={true} />,
    $queries: {
      changePage: { $call: 'ui.history.push' },
      app: {
        user: {
          selectedPortfolio: true
        }
      },
      auth: {
        vascoActivated: true,
        entitlements: {
          trading: true
        }
      },
      setComponentProps: { $set: 'ui.componentProps' },
      setInitialPath: { $set: 'ui.component.initialPath' },
      portfolio: {
        referenceCurrency: true,
        assetNames: true,
        [assetCategory]: {
          ...HeaderComponent.getFragment('assetData'),
          ...RowComponent.getFragment('assetData'),
          static: {
            ...SortingHeaderComponent.getFragment('uiStatic'),
            ...AssetAccordion.getFragment('uiStatic'),
            ...ExpandedRowComponent.getFragment('uiStatic'),
          },
          state: {
            ...AssetAccordion.getFragment('state'),
          },
          positionsByPosId: {
            isin: true,
            secID: true,
            name: true,
            ...RowComponent.getFragment('row'),
            ...ExpandedRowComponent.getFragment('row'),
          },
          positionsSorted: {
            $type: 'list',
            $range: {
              offset: ref(`portfolio.${assetCategory}.${positionsProp}.pageOffset`),
              length: ref(`portfolio.${assetCategory}.${positionsProp}.pageSize`),
            },
            // TODO defer
            // $node: defer({
            $node: {
              isin: true, // TODO: remove when DGUI-948 is fixed
              secID: true,
              name: true,
              ...RowComponent.getFragment('row'),
              ...ExpandedRowComponent.getFragment('row'),
            },
          },
          [positionsProp]: {
            length: true,
            pageSize: true,
            pageOffset: true,
            setPageOffset: { $set: 'pageOffset' },
          },
        },
      },
      i18n: {
        messages: true,
      },
      ui: {
        static: {
          abbreviationRules: true,
        },
        state: {
          portfolio: {
            [assetCategory]: {
              ...SortingHeaderComponent.getFragment('state'),
              resetSort: { $call: 'resetSort' },
            }
          },
        },
      },
      search: {
        filter: {
          positionId: true,
        },
      },
      screen: {
        width: true,
        height: true,
        isSmall: true,
      },
      marque: {
        loginDissmiss: true
      }
    },
  })(AssetPositions);
}
